module.exports = __webpack_public_path__ + "img/tab_item07.848d5f88.png";